import Anchor from '../components/general/anchor.component';
import VideoBehindText from '../components/video-image-background/video-behind-text.component';


const RadioPage = () => (
   <VideoBehindText mainText="Radio" url="bg.jpg">
      <div className="flex flex-wrap">
         <div className="m-4">
            <h1 className="text-xl">Music From The Heart</h1>
            <em>Content Producer:</em> Allan Russell<br />
            <em>Audio Link:</em> <Anchor url="https://audioboom.com/posts/7821376-music-from-the-heart" text="Music From The Heart" />
            <img src="RNIBConnectRadioLogo.png" alt="RNIB Connect Radio Logo"  width="200" />
         </div>
         <div className="m-4">
            <h1 className="text-xl">Batman and Ethan</h1>
            <em>Content Producer:</em> Helena Merriman<br />
            <em>Audio Link:</em> <Anchor url="https://www.bbc.co.uk/programmes/b0709v4m" text="Batman and Ethan" />
            <img src="BBC_Radio_4.svg" alt="BBC Radio 4 logo" width="100" />
         </div>
         <div className="m-4">
            <h1 className="text-xl">Tony Luciani and Ethan</h1>
            <em>Content Producer:</em> Alisa Siegel<br />
            <em>Audio Link:</em> <Anchor url="https://www.cbc.ca/radio/sunday/january-6-2019-the-sunday-edition-with-michael-enright-1.4964589/how-a-canadian-artist-captured-the-vision-of-a-blind-piano-prodigy-1.4964754?x-eu-country=true" text="CBC Radio Profile" />
            <img src="CBC_Radio_Logo.svg" alt="CBC Radio logo" width="100" />
         </div>

      </div>
   </VideoBehindText>
);

export default RadioPage;
